import '@/utils/armsTrackUtil';
import 'reflect-metadata';
import '@/assets/css/main.less';

import { createAuthPlugin, handlerMetaPlugin } from '@/utils';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import {
  Button,
  Form,
  Input,
  Divider,
  Space,
  Row,
  Col,
  Dropdown,
  DatePicker,
  Menu,
  Pagination,
  Cascader,
  Radio,
  Select,
  Avatar,
  Empty,
  Image,
  Popover,
  Table,
  Tag,
  Modal,
  Spin,
  ConfigProvider,
  Carousel,
  Tabs,
  Checkbox,
  InputNumber,
  Upload,
  Progress,
  Card,
  Tooltip,
} from 'ant-design-vue';

const middles = [
  createAuthPlugin(),
  handlerMetaPlugin(),
  router,
  Button,
  Form,
  Input,
  Divider,
  Space,
  Row,
  Col,
  Dropdown,
  DatePicker,
  Menu,
  Pagination,
  Cascader,
  Radio,
  Select,
  Avatar,
  Empty,
  Image,
  Popover,
  Table,
  Tag,
  Modal,
  Spin,
  ConfigProvider,
  Carousel,
  Tabs,
  Checkbox,
  InputNumber,
  Upload,
  Progress,
  Card,
  Tooltip,
];

const app = createApp(App);

middles.forEach(mid => app.use(mid));

app.mount('#app');
